import { ReactElement } from 'react'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import { IErrorMessageProps } from './types'
import { isString } from 'lodash'

const ErrorWrapper = styled.div`
  margin: 5px 0;
`

const ErrorMessage = ({ errors = [], children, ...props }: IErrorMessageProps): ReactElement => {
  if (errors && errors.length > 0) {
    return (
      <div>
        {errors.map((error, index) => {
          return <ErrorMessage key={index}>{isString(error) ? error : JSON.stringify(error)}</ErrorMessage>
        })}
      </div>
    )
  }

  return (
    <ErrorWrapper {...props}>
      <Heading.Error>{children}</Heading.Error>
    </ErrorWrapper>
  )
}

export { ErrorMessage }
